module.exports = __webpack_public_path__ + "static/olive-18f107810d4cc3eb99be0254836ad5cf.svg";